/* @refresh reload */
import { render } from 'solid-js/web';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../index.css';
import AdminApp from './AdminApp';
import { setupPreviewMode } from '../services/fakeBackend';

setupPreviewMode();

const root = document.getElementById('root');

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    'Root element not found. Did you forget to add it to admin.html? Or maybe the id attribute got misspelled?',
  );
}

render(() => <AdminApp />, root!);
